<template>
  <div v-if="isDesktop">
    <SiestaTunein />
    <SiestaShare :points="points" :is-results="isResults" />
  </div>
  <div v-else>
    <SiestaShare :points="points" :is-results="isResults" />
    <SiestaTunein class="tune-in-mobile" />
  </div>
</template>

<script>
import SiestaTunein from "@/components/SiestaTunein";
import SiestaShare from "@/components/SiestaShare";
import { ActivitySize } from "@/store";

export default {
  name: "siesta-footer",
  props: {
    isResults: Boolean,
    points: Number,
  },
  components: {
    SiestaTunein,
    SiestaShare,
  },
  computed: {
    isDesktop() {
      return this.$store.state.size === ActivitySize.DESKTOP;
    },
  },
};
</script>

<style lang="scss" scoped>
.tune-in-mobile {
  margin-top: rems(10px);
}
</style>
